import { useMutation, useQueryClient } from 'react-query';
import { toastr } from 'react-redux-toastr';
import RentForecastService from '../../services/rentForecastService';
import useIntl from '../../hooks/useIntl';
import messages from './messages';
import {
  DEFAULT_COLUMN_ORDER,
  DEFAULT_SETTINGS_STATE,
  DEFAULT_SHOW_HIDE_STATE,
  DEFAULT_SHOW_HIDE_STATE_RD,
} from './constants';

const useRentForecastMutation = (
  organizationId,
  propertyId,
  setCurrentRentForecast,
  propertyIsRD,
) => {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const queryKey = ['useRentForecastQuery', organizationId, propertyId];

  return useMutation(
    async (rentForecastValues) => {
      const payload = JSON.stringify({
        name: rentForecastValues.name,
        year: rentForecastValues.year.toString(),
        columnOrder: DEFAULT_COLUMN_ORDER,
        showHideState: propertyIsRD
          ? DEFAULT_SHOW_HIDE_STATE_RD
          : DEFAULT_SHOW_HIDE_STATE,
        settingsState: DEFAULT_SETTINGS_STATE,
      });

      return new RentForecastService().createRentForecast(
        organizationId,
        propertyId,
        payload,
      );
    },
    {
      onSuccess: (result, variables, context) => {
        toastr.success(
          intl.formatMessage(messages.success),
          intl.formatMessage(messages.createdForecast),
        );

        queryClient.invalidateQueries(queryKey).then(() => {
          setCurrentRentForecast(result?.rentForecasts);
        });

        if (context?.onSuccess) {
          context.onSuccess();
        }
      },
      onError: (error) => {
        toastr.error('Error', error.toString(), {
          timeOut: 0,
          showCloseButton: true,
        });
      },
    },
  );
};

export default useRentForecastMutation;
